module.exports = __webpack_public_path__ + "img/fb.11a70ee8.png";